import $ from 'jquery'
export const popupController = function(innerHtml, closeSvg = '') {
  
  let popupObject = null;
  
  const init = function() {  
    popupObject = $( getPopupHtml() );
    popupObject.appendTo( $('body') );
    popupObject
      .on('click', '.close-layer', closeClicked)
      .on('click', '.close-btn', closeClicked)
  }
  
  const getPopupHtml = function() {
    const close = closeSvg || 
    `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18px" height="18px" viewBox="0 0 40 40">
    <path fill-rule="evenodd"  fill="#5C8727" d="M-0.002,40.999 L-0.002,-0.002 L40.998,-0.002 L40.998,40.999 L-0.002,40.999 ZM32.456,10.949 L30.048,8.541 L20.497,18.090 L10.948,8.541 L8.538,10.949 L18.090,20.499 L8.538,30.049 L10.948,32.457 L20.497,22.907 L30.048,32.457 L32.456,30.049 L22.907,20.499 L32.456,10.949 Z"/>
  </svg>`;
    return `
      <div class="icit-popup">
        <div class="close-layer"></div>
        <div class="popup-inner">
          <a href="#" class="close-btn">
            ${close}
          </a>
          ${innerHtml}
        </div>
      </div>
    `;
  }
  
  const show = function() {
    popupObject.fadeIn();
    $(document).trigger('popup_state_changed');
  }
  
  const closeClicked = function(e) {
    e.preventDefault();
    close();
  }
  
  const close = function() {
    popupObject.fadeOut(500, function() {
      popupObject.remove();
      $(document).trigger('popup_state_changed');
    });
  }
  
  const withPadding = function() {
    popupObject.find('.popup-inner').addClass('with-padding');
    // return self;
  }
  
  const makeUnclosibble = function() {
    popupObject
      .off('click', '.close-layer', closeClicked)
      .off('click', '.close-btn', closeClicked);
    
    popupObject.find('.close-btn').hide();
    // return self;
  }
  
  const makeClosable = function() {
    popupObject
      .on('click', '.close-layer', closeClicked)
      .on('click', '.close-btn', closeClicked);
    
    popupObject.find('.close-btn').show();
    // return self;
  }
  
  const addClass = function(className) {
    popupObject.addClass(className);
    // return self;
  }
  
  const removeClass = function(className) {
    popupObject.removeClass(className);
    // return self;
  }

  const getObject = function() {
    return popupObject;
  }
  
  init();
  return {
    show,
    close,
    getObject,
    addClass,
    makeClosable,
    makeUnclosibble,
    withPadding,
    removeClass
  }
  
}